import { render, staticRenderFns } from "./shipping_info.vue?vue&type=template&id=f54fc140&scoped=true&"
import script from "./shipping_info.vue?vue&type=script&lang=js&"
export * from "./shipping_info.vue?vue&type=script&lang=js&"
import style0 from "./shipping_info.vue?vue&type=style&index=0&id=f54fc140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54fc140",
  null
  
)

export default component.exports